var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("alert " + _vm.stateClass + " alert-state text-center"),attrs:{"role":"alert"}},[_vm._v(" "+_vm._s(_vm.archived_at ? 'Оплачено' : 'Активный')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }